export default __webpack_public_path__ + "static/scott-s-ad185cddc35e161be312a25b166b2773.png";